export default {
  setTemplatesByType (state, { templateType, templates }) {
    if (state.templates[templateType] !== undefined) {
      state.templates[templateType] = templates
    }
  },

  addTemplate (state, { templateType, template }) {
    if (state.templates[templateType] !== undefined && Array.isArray(state.templates[templateType])) {
      state.templates[templateType].push(template)
    }
  },

  updateTemplate (state, { templateType, template }) {
    if (state.templates[templateType] !== undefined) {
      const index = state.templates[templateType].findIndex(t => t.id === template.id)
      if (index !== -1) {
        state.templates[templateType].splice(index, 1, template)
      }
    }
  },

  removeTemplate (state, { templateType, templateId }) {
    if (state.templates[templateType] !== undefined) {
      const index = state.templates[templateType].findIndex(t => t.id === templateId)
      if (index !== -1) {
        state.templates[templateType].splice(index, 1)
      }
    }
  },

  setLoadingByType (state, { templateType, loading }) {
    if (state.loading[templateType] !== undefined) {
      state.loading[templateType] = loading
    }
  },

  setLanguages (state, languages) {
    state.languages = languages
  },

  setLanguagesLoading (state, loading) {
    state.languagesLoading = loading
  },
}
